import { dateConfig, DEVICE_DETAILS } from "config";
import moment from "moment";
import { collectionGroup, collectionRef, db } from "./firebase";
import { COUNTRYCODE, EQUALS } from "../config/CONSTANTS";
import { createTimesheetfromPunch } from "../pages/Timesheet/utils";
import { getPunch, getUniqueID } from "../utils/punch";
import { getWeekNumber } from "../services";
const LOCATIONS = "locations";

const PUNCHES = "punches";

export const getLocationForCountry = async (
  countryCode,
  alternateCountryCode
) => {
  console.log("services > dsc > getLocationDevDetails called...", countryCode);
  return new Promise((res, rej) => {
    try {
      let CountryCode = countryCode
        ? countryCode !== "testCountry"
          ? countryCode.toLowerCase()
          : countryCode
        : null;

      let countriesForLocations = [CountryCode];
      let cGroup = collectionGroup("buildings");
      if (alternateCountryCode)
        countriesForLocations.push(alternateCountryCode);
      if (CountryCode && CountryCode !== "testCountry")
        cGroup = cGroup.where(COUNTRYCODE, "in", countriesForLocations);

      return cGroup
        .get()
        .then((snapshot) => {
          // console.log("------- getLocationDevDetails snapshot in dsc js------",snapshot);
          const buildings = snapshot.docs
            .map((doc) => ({
              id: doc.id,
              data: doc.data(),
            }))
            .filter((e) =>
              e.data.collectionName ? e.data.collectionName == LOCATIONS : false
            );

          //  let buildingsData  = buildings.filter((e) => e.data.country == CountryCode)
          let buildingsData = buildings;
          //.filter((e) =>
          //country == "" ? true : e.data.country == country)
          //.filter((e)=> e.data.activityEnabled === true);
          if (buildingsData.length === 0) {
            buildingsData = buildings;
          }
          const obj = {};
          for (let item of buildingsData) {
            const { id, data } = item;
            //console.log("id is", id, "data is ", data);
            const districtName = data.districtName;
            if (!obj[districtName]) {
              obj[districtName] = { [id]: data };
            } else {
              obj[districtName][id] = data;
            }
          }

          const output = Object.keys(obj).map((key) => ({
            district: key,
            buildings: obj[key],
          }));
          console.log("Districts", output);

          res(output);
        })
        .catch((err) => {
          console.error(
            "in services > bulkUpload > getLocationForCountry, err===" + err
          );
          rej(err);
        });
    } catch (error) {
      console.error(
        "in services > dsc > getLocationDevDetails, err===" + error
      );
      rej(error);
    }
  });
};

const mapBuildingsToDistricts = (buildings) => {
  const obj = {};
  for (const item of buildings) {
    const { id, data } = item;
    const districtName = data.districtName;
    if (!districtName) continue;
    if (!obj[districtName]) {
      obj[districtName] = { [id]: data };
    } else {
      obj[districtName][id] = data;
    }
  }
  return Object.keys(obj).map((key) => ({
    district: key,
    buildings: obj[key],
  }));
};

export const getLocationsForCountryCodes = async (countryCodes = []) => {
  const normalizedCodes = [
    ...new Set(
      countryCodes
        .filter(Boolean)
        .map((code) =>
          code !== "testCountry" ? code.toLowerCase() : code
        )
    ),
  ];

  if (!normalizedCodes.length) {
    return [];
  }

  return new Promise((res, rej) => {
    try {
      const batches = [];
      for (let i = 0; i < normalizedCodes.length; i += 10) {
        batches.push(normalizedCodes.slice(i, i + 10));
      }

      Promise.all(
        batches.map((batch) => {
          let cGroup = collectionGroup("buildings").where(
            COUNTRYCODE,
            "in",
            batch
          );
          return cGroup.get();
        })
      )
        .then((snapshots) => {
          const buildings = snapshots
            .flatMap((snapshot) => snapshot.docs)
            .map((doc) => ({
              id: doc.id,
              data: doc.data(),
            }))
            .filter((e) =>
              e.data.collectionName ? e.data.collectionName === LOCATIONS : false
            );
          res(mapBuildingsToDistricts(buildings));
        })
        .catch((err) => {
          console.error(
            "in services > bulkUpload > getLocationsForCountryCodes, err===",
            err
          );
          rej(err);
        });
    } catch (error) {
      console.error(
        "in services > bulkUpload > getLocationsForCountryCodes, err===",
        error
      );
      rej(error);
    }
  });
};

export function saveBulkEntries(data) {
  console.log("bulkUploadData ", data);
  let batch = db.batch();
  let start = data.weekPicker;
  //let index = 0;
  return new Promise(async (resolve, reject) => {
    try {
      let records = data.records;
      // let punches = Array.from(Array(7)).map(e=>[]);
      let punches = [];
      console.log("Arrays", punches);

      for (let i = 0; i < 7; ++i) {
        let day = `day${i + 1}`;
        let rowIndex = 0;
        let startTime = '08:00';
        let previousEndTime = 0;
        if(data.workerSchedule 
            && Object.keys(data.workerSchedule).length > 0 
            && data.workerSchedule.workingHoursEnabled
            ){
                  let workerSchedule = data.workerSchedule;
                  let curDayName = moment().day(i).format('dddd');
                  let workerDaySlots = workerSchedule?.[curDayName]?.slots;
                  let startTimeSlot = workerDaySlots && workerDaySlots.length>0 ?workerDaySlots[0]?.start:undefined;
                  if(startTimeSlot){
                    startTime = moment(startTimeSlot,['hh:mma']).format('HH:mm');
                  }
            }
        for (let j = 0; j < records.length; ++j) {
          let record = records[j];
          let hours = record[day];
          if (hours !== 0 && hours > 0) {
            rowIndex++;
            if (rowIndex == 1) {
              // First Day Record In column
              let punch = {};

              //let endTime = parseFloat(startTime) + parseFloat(hours);
              let endTime = moment(startTime, 'HH:mm').add(hours, 'hours').format('HH:mm');
              previousEndTime = endTime;

              let inLocalTS = moment(start)
                .startOf("week")
                .add(i, "days")
                .add(moment.duration(startTime))
                .format(dateConfig.format4)
                .toString();
              let outLocalTS = moment(start)
                .startOf("week")
                .add(i, "days")
                .add(moment.duration(endTime))
                .format(dateConfig.format4)
                .toString();
              punch.inLocalTS = inLocalTS;
              punch.outLocalTS = outLocalTS;
              punch.inTS = new Date(inLocalTS).toISOString();
              punch.outTS = new Date(outLocalTS).toISOString();
              if(data.selectedWorker.timezone 
                && Object.keys(data.selectedWorker.timezone).length>0
                && data.selectedWorker.timezone.offset
                ){
                punch.inTS =  moment(inLocalTS).subtract(data.selectedWorker.timezone.offset * 60 * 60 * 1000).format( 'YYYY-MM-DDTHH:mm:ss.000')+'Z';
                punch.outTS = moment(outLocalTS).subtract(data.selectedWorker.timezone.offset * 60 * 60 * 1000).format( 'YYYY-MM-DDTHH:mm:ss.000')+'Z';
              }
              punch.actionBy = data.actionBy;
              punch.actionTS = data.actionTS;
              punch.buildingId = data.buildingId;
              punch.districtId = data.districtId;
              punch.customerSite = "";
              if (data.customerSite)
                punch.customerSite = data.customerSite.trim();
              punch.workerId = data.selectedWorker.workerId;
              punch.activityName = "OUT";
              punch.status = "new";
              punch.category = "punch";
              punch.exceptionName = "";
              punch.isException = false;
              punch.jobName = record.family;
              punch.activityGroup = record.group;
              punch.jobProjectInfo = record.details;
              punch.projectDetails = "";
              if (record.projectDetails)
                punch.projectDetails = record.projectDetails;
              punch.weekNumber = getWeekNumber(outLocalTS);
              let duration = 0;
              if (outLocalTS) {
                const end = moment(outLocalTS && outLocalTS.substr(0, 16));
                const start = moment(inLocalTS && inLocalTS.substr(0, 16));
                if (start.isValid() && end.isValid()) {
                  const diff = moment.duration(end.diff(start));
                  duration = diff.asHours();
                  duration = duration.toFixed(2);
                }
              }
              punch.duration = parseFloat(duration);
              const version = getUniqueID();
              punch.version = version;
              if (record.showFreeForm) punch.jobProjectInfo = record.freeForm;
              punch.deviceDetails = DEVICE_DETAILS;
              // punches[i].push(punch)
              punches.push(punch);
            } else {
              // Other Day Records (Add 1 minute to start time)
              let punch = {};
              let startTime = previousEndTime; /* Add 1 minute here */
              let endTime = moment(startTime, 'HH:mm').add(hours, 'hours').format('HH:mm');
              previousEndTime = endTime;

              let inLocalTS = moment(start)
                .startOf("week")
                .add(i, "days")
                .add(moment.duration(startTime))
                .format(dateConfig.format4)
                .toString();
              let outLocalTS = moment(start)
                .startOf("week")
                .add(i, "days")
                .add(moment.duration(endTime))
                .format(dateConfig.format4)
                .toString();
              punch.inLocalTS = inLocalTS;
              punch.outLocalTS = outLocalTS;
              punch.inTS = new Date(inLocalTS).toISOString();
              punch.outTS = new Date(outLocalTS).toISOString();
              if(data.selectedWorker.timezone 
                && Object.keys(data.selectedWorker.timezone).length>0
                && data.selectedWorker.timezone.offset
                ){
                punch.inTS =  moment(inLocalTS).subtract(data.selectedWorker.timezone.offset * 60 * 60 * 1000).format( 'YYYY-MM-DDTHH:mm:ss.000')+'Z';
                punch.outTS = moment(outLocalTS).subtract(data.selectedWorker.timezone.offset * 60 * 60 * 1000).format( 'YYYY-MM-DDTHH:mm:ss.000')+'Z';
              }
              punch.actionBy = data.actionBy;
              punch.actionTS = data.actionTS;
              punch.buildingId = data.buildingId;
              punch.districtId = data.districtId;
              punch.workerId = data.selectedWorker.workerId;
              punch.customerSite = "";
              if (data.customerSite)
                punch.customerSite = data.customerSite.trim();
              punch.activityName = "OUT";
              punch.status = "new";
              punch.category = "punch";
              punch.exceptionName = "";
              punch.isException = false;
              punch.jobName = record.family;
              punch.activityGroup = record.group;
              punch.jobProjectInfo = record.details;
              punch.projectDetails = "";
              if (record.projectDetails)
                punch.projectDetails = record.projectDetails;
              punch.weekNumber = getWeekNumber(outLocalTS);
              let duration = 0;
              if (outLocalTS) {
                const end = moment(outLocalTS && outLocalTS.substr(0, 16));
                const start = moment(inLocalTS && inLocalTS.substr(0, 16));
                if (start.isValid() && end.isValid()) {
                  const diff = moment.duration(end.diff(start));
                  duration = diff.asHours();
                  duration = duration.toFixed(2);
                }
              }
              punch.duration = parseFloat(duration);
              const version = getUniqueID();
              punch.version = version;
              if (record.showFreeForm) punch.jobProjectInfo = record.freeForm;
              punch.deviceDetails = DEVICE_DETAILS;
              // punches[i].push(punch)
              punches.push(punch);
            }
          }
        }
      }
      if (!punches || punches.length <= 0)
        reject(new Error("NO data to upload"));
      let punchesArray = [];
      console.log("Punches Array Data", punches);
      for (let j = 0; j < punches.length; j++) {
        let punchData = punches[j];

        const docRef = collectionRef(PUNCHES).doc();
        console.log("punch Id", docRef.id);
        let punchRecord = { ...punchData, id: docRef.id };
        console.log("punchRecord", punchRecord);
        punchesArray.push({ ...punchRecord });
        batch.set(docRef, punchData, { merge: true });
      }
      await batch.commit();
      await createTimesheetfromPunch(punchesArray)
        .then((result) => {
          if (result) {
            resolve(punches);
          }
        })
        .catch((error) => {
          console.log("error:", error);
          reject(error);
        });
      console.log("Successfully Uploaded bulk data");
    } catch (error) {
      console.log(error);
      reject(new Error("Bulk Upload Crashed"));
    }
  });
}
